// The description ("Beschreibung") input of an uploaded photo or file, for rows built
// after a direct upload — the JS twin of app/views/shared/_upload_caption_input.html.erb.
// maxLength comes from the view (UploadCaption::MAX_LENGTH); name is left off when the
// controller posts the value itself.
export function buildCaptionInput({ placeholder = "", maxLength, name } = {}) {
  const input = document.createElement("input")
  input.type = "text"
  input.autocomplete = "off"
  if (name) input.name = name
  if (maxLength) input.maxLength = maxLength
  input.placeholder = placeholder
  input.setAttribute("aria-label", placeholder)
  input.className =
    "mt-2 block w-full rounded-md border-gray-300 text-sm shadow-xs focus:border-green-500 focus:ring-green-500"
  return input
}
